function BackEnd() {
  return (
    <div className="skills_content">
      <h3 className="skills_title">FrameWorks</h3>

      <div className="skills_box">
        <div className="skills_group">
          <div className="skills_data">
            <i className="bx bx-badge-check"></i>

            <div>
              <div className="skills_name">jQuery</div>
              <span className="skills_level">Intermediate</span>
            </div>
          </div>
          <div className="skills_data">
            <i className="bx bx-badge-check"></i>

            <div>
              <div className="skills_name">AlpineJs</div>
              <span className="skills_level">Intermediate</span>
            </div>
          </div>
          <div className="skills_data">
            <i className="bx bx-badge-check"></i>

            <div>
              <div className="skills_name">Redux</div>
              <span className="skills_level">Intermediate</span>
            </div>
          </div>
        </div>

        <div className="skills_group">
          <div className="skills_data">
            <i className="bx bx-badge-check"></i>

            <div>
              <div className="skills_name">BootStrap</div>
              <span className="skills_level">Advanced</span>
            </div>
          </div>
          <div className="skills_data">
            <i className="bx bx-badge-check"></i>

            <div>
              <div className="skills_name">Sass</div>
              <span className="skills_level">Intermediate</span>
            </div>
          </div>
          <div className="skills_data">
            <i className="bx bx-badge-check"></i>

            <div>
              <div className="skills_name">Tailwindcss</div>
              <span className="skills_level">Advanced</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BackEnd;
